var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#male_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.216 115H6.379s-2.065-21.341-2.36-28.48c-.406-9.806 7.447-18.027 17.216-18.983l13.746-1.345a152.017 152.017 0 0 1 29.635 0l13.745 1.345c9.77.956 17.623 9.18 17.217 18.984-.295 7.138-2.36 28.479-2.36 28.479h-.002Z",
    fill: "#8EC2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 100H62c0-4 2.93-26.225 2.93-31.66v-2.122l-.319-.03a152.032 152.032 0 0 0-29.635 0l-1.026.1v2.051C33.95 73.075 37.5 96 37.5 100Z",
    fill: "#262A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.589 58.84v8.902s3.303 1.48 10.854 1.48c7.551 0 11.563-1.18 11.563-1.18v-9.203H38.589Z",
    fill: "#E49C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.006 58.84H38.589v4.823S44.594 67 49.033 67c5.467 0 11.574-5.075 11.973-4.71v-3.45ZM67.967 34.77h1.18c.651 0 1.18.529 1.18 1.18v8.73a1.18 1.18 0 0 1-1.18 1.18h-1.18V34.77ZM32.097 45.863h-1.18a1.18 1.18 0 0 1-1.18-1.18v-8.73c0-.652.529-1.18 1.18-1.18h1.18v11.09Z",
    fill: "#D5824E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.033 11.645c-10.295 0-18.642 8.346-18.642 18.642v13.922c0 6.097 2.929 11.513 7.457 14.913a18.557 18.557 0 0 0 11.185 3.728c10.295 0 18.642-8.346 18.642-18.641V30.287c0-10.296-8.346-18.642-18.642-18.642Z",
    fill: "#E49C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.033 11.645c-8.054 0-14.916 5.109-17.52 12.263.016.005 14.766 4.467 28.375 6.615 4.483.707 7.787 4.247 7.787 4.247v-4.483c0-10.296-8.347-18.642-18.642-18.642ZM54.5 53c-3.2-1.6-8.333-1.667-10.5-1.5-.167 0-.6-.2-1-1-.5-1 5.5-1 10-1 3.6 0 5.833 4 6.5 6l-5-2.5Z",
    fill: "#D5824E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.11 23.444s19.587 5.663 29.497 5.899c6.371 0 5.9-.942 5.9-3.537 0-2.596-.657-13.092-7.408-15.277l3.016-2.013s-17.79-6.074-26.52-1.59C31.862 11.409 27.38 20.039 28.56 28.703c4.955-5.561 7.55-5.26 7.55-5.26Z",
    fill: "#19181C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 7.5c-3.667-.667-11.5-.8-13.5 4-2.5 6 0 11.5 0 11.5-1.667.5-5 2.3-5 5.5 0 1.963.843 3.324 1.642 4.615.83 1.339 1.613 2.603 1.358 4.385-.178 1.245-1.241 2.364-2.313 3.49-1.941 2.042-3.909 4.11-.687 7.01 2.094 1.885 4.1 2.98 5.873 3.948C29.83 53.29 31.838 54.385 33 57c2 4.5 13 8 15.5 8.5S65.5 59 67 57c1.2-1.6 3.5-.667 4.5 0 2-1.5 6-9 6-9h-6c-.761 0-.502-.14.226-.53 1.663-.894 5.774-3.102 5.774-7.97 0-3.96-2.88-5.04-4.84-5.774-1.503-.563-2.463-.923-1.16-2.226 3-3 5-7.5 2.5-12.5-.429-.857-.828-1.817-1.24-2.81C70.764 11.394 68.457 5.843 61 7.5l-.902-.509C52.403 2.645 44.812-1.643 40 7.501Zm8.85 40.12c-4.234.422-8.85.884-8.85 6.38 0 6-7-6.5-7-11.5v-14c0-4.4 1.667-8.167 2.5-9.5L67 23v12.5c0 7-3.5 22.5-6 18.5-.274-.439-.524-.86-.763-1.26v-.002C58.3 49.481 57.121 47.5 50 47.5c-.378.042-.762.08-1.15.12Zm5.355 10.264c1.516.564 2.405.895 3.295-.884 1.5-3-2-6.5-6.5-6.5s-8.5.5-8.5 3.5.01 6 7.5 3c1.831 0 3.166.497 4.205.884Z",
    fill: "#19181C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.217 35.95a1.06 1.06 0 0 1-1.061-1.062V24.27a1.06 1.06 0 0 1 1.061-1.062c.588 0 4.333-.151 3.894.236-4.012 3.54-2.832 11.444-2.832 11.444a1.06 1.06 0 0 1-1.062 1.062ZM68.085 35.95a1.06 1.06 0 0 0 1.062-1.062V24.27a1.06 1.06 0 0 0-1.062-1.062c-.588 0-4.333-.151-3.894.236 4.012 3.54 2.832 11.444 2.832 11.444a1.06 1.06 0 0 0 1.062 1.062Z",
    fill: "#19181C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "male_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "#fff"
  })))));
};
export default SvgMale;